class MkCommunityStories extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.track = this.querySelector('[data-story-track]');
    this.dialog = this.querySelector('[data-story-dialog]');
    this.dialogVideo = this.dialog?.querySelector('.mk-community-stories__dialog-video');
    this.dialogLabel = this.dialog?.querySelector('[data-story-dialog-label]');
    this.lastTrigger = null;

    this.querySelectorAll('[data-story-nav]').forEach((control) => {
      control.addEventListener('click', () => {
        const direction = control.dataset.storyNav === 'next' ? 1 : -1;
        const amount = (this.track?.clientWidth || 320) * 0.82 * direction;
        this.track?.scrollBy({ left: amount, behavior: 'smooth' });
      });
    });

    this.querySelectorAll('[data-story-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.openStory(trigger));
    });

    this.querySelector('[data-story-close]')?.addEventListener('click', () => this.closeStory());
    this.dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.closeStory();
    });
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.closeStory();
    });
    this.dialog?.addEventListener('close', () => this.resetVideo());
  }

  openStory(trigger) {
    if (!this.dialog || !this.dialogVideo) return;
    this.lastTrigger = trigger;
    const source = trigger.dataset.videoSource;
    const poster = trigger.dataset.posterSource;

    this.dialogVideo.poster = poster || '';
    if (source) {
      this.dialogVideo.src = source;
      this.dialogVideo.load();
    }
    if (this.dialogLabel) this.dialogLabel.textContent = trigger.dataset.storyTitle || 'Customer story';

    if (!this.dialog.open) this.dialog.showModal();
    window.requestAnimationFrame(() => {
      this.dialogVideo.play().catch(() => {
        // Native controls remain available if autoplay is restricted.
      });
    });
  }

  closeStory() {
    if (!this.dialog?.open) return;
    this.dialog.close();
    this.lastTrigger?.focus({ preventScroll: true });
  }

  resetVideo() {
    if (!this.dialogVideo) return;
    this.dialogVideo.pause();
    this.dialogVideo.removeAttribute('src');
    this.dialogVideo.removeAttribute('poster');
    this.dialogVideo.load();
    if (this.dialogLabel) this.dialogLabel.textContent = '';
  }
}

if (!customElements.get('mk-community-stories')) {
  customElements.define('mk-community-stories', MkCommunityStories);
}
